var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.75L13.456 1l11.21 20L37.124 1l11.21 20 11.21-20L72 21 83.21 1l12.457 20 11.21-20 12.456 20 12.456-20L143 19.75",
    stroke: "#387"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDQiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAxNDQgMjMiIGZpbGw9Im5vbmUiPgogICAgPHBhdGggZD0iTTEgMTkuNzVMMTMuNDU2MSAxTDI0LjY2NjcgMjFMMzcuMTIyOCAxTDQ4LjMzMzMgMjFMNTkuNTQzOSAxTDcyIDIxTDgzLjIxMDUgMUw5NS42NjY3IDIxTDEwNi44NzcgMUwxMTkuMzMzIDIxTDEzMS43ODkgMUwxNDMgMTkuNzUiIHN0cm9rZT0iIzMzODg3NyIvPgo8L3N2Zz4K";
export { SvgLine as ReactComponent };